import axios from "axios";
import Config from "../../config";

const ReportDetailLinkedPage = params => {
    const {channel_id, start_date, end_date} = params
    return axios({
        method: "POST",
        url: (Config.url || '') + "/api/report/detail-linked-page",
        data: { channel_id, start_date, end_date }
    });
};

export default ReportDetailLinkedPage;
